import React from 'react';
import { FormattedMessage } from 'react-intl';

import reduxStore from './../../../../reduxStore';
import actions from './../../BatchUpload.actions';

import CustomTableBody from './../../../../reusable/CustomTableBody/CustomTableBody.index.jsx';
import InfiniteScrollTable from './../../../../reusable/InfiniteScrollTable/InfiniteScrollTable.index.jsx';

import {
    SimpleArrayCell
} from './../../../../reusable/CustomTableBody/templates/CustomTableBody.predefinedCellTypes.jsx';

export default class PreviewPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = reduxStore.getState().batchUpload;
        //this.continueAndCommit = this.continueAndCommit.bind(this);

        /*
         * We initialize all table parameters here because they will stay fixed and in the past we did the mistake of
         * initializing them in the render() method, thus causing the table to unnecessarily re-render. This caused bug
         * RMM-366 ({@link https://jira.moreover.com/browse/RMM-366}).
         */
        this.columnWidths = [12, 12, 10, 10, 12, 10, 10, 10, 14];
        this.urlParams = {
            sortBy:    'name',
            direction: 'asc'
        };
        this.rowsModel = [
            {
                fieldId: 'companyTitle',
                fieldType: 'string'
            },
            {
                fieldId: 'customerCompanyId',
                fieldType: 'string'
            },
            {
                fieldId:   'dunsNumber',
                fieldType: 'string'
            },
            {
                fieldId:   'experianBusinessId',
                fieldType: 'string'
            },
            {
                fieldId:   'entityUrl',
                fieldType: 'string'
            },
            {
                fieldId: 'companyName',
                fieldType: SimpleArrayCell
            },
            {
                fieldId: 'contextKeywords',
                fieldType: SimpleArrayCell
            },
            {
                fieldId: 'exclusionKeywords',
                fieldType: SimpleArrayCell
            },
            {
                fieldId: 'categoriesAsString',
                fieldType: 'string'
            }
        ];

    }

    componentWillMount() {
        
        this.unsubscribe = reduxStore.subscribe(
            () => {
                this.setState(reduxStore.getState().batchUpload);
            }
        );
        
    }

    componentWillUnmount() {
        this.unsubscribe();
    }

    componentDidMount() {

        actions.checkFormattingEntriesCount(this.state.uploadId);
        
    }

    render() {

        return (

            <div className="upload-preview-page">

                <div className="upload-preview-page__notice">

                    <div className="content">
                        <span>{this.state.checkFormattingEntriesCount}</span>
                        &nbsp;
                        <FormattedMessage id="Entities_Preview_UIText_previewCompanies.notice" />
                    </div>

                    <div className="top-buttons">
                        <button className="button-primary-lg continue"
                                onClick={actions.continueAndCommit}>
                            <FormattedMessage id="General_CoreFunctionality_UIText_general.continue" />
                        </button>

                        <button
                            className="button-secondary-lg cancel"
                            onClick={actions.resetUploadToInitial}>
                            <FormattedMessage id="General_CoreFunctionality_UIText_general.cancel" />
                        </button>
                    </div>

                </div>

                <InfiniteScrollTable tableId="preview-companies-table"
                                     columnWidths={this.columnWidths}
                                     rowsModel={this.rowsModel}>
                    <thead className="custom-table-head">
                        <tr>
                            <th><FormattedMessage id="Entities_Preview_UIText_previewCompanies.companyName" /></th>
                            <th><FormattedMessage id="Entities_Preview_UIText_previewCompanies.uniqueCompanyId" /></th>
                            <th><FormattedMessage id="Entities_Preview_UIText_previewCompanies.companyDUNS" /></th>
                            <th><FormattedMessage id="Entities_Preview_UIText_previewCompanies.ExperianId" /></th>
                            <th><FormattedMessage id="Entities_Preview_UIText_previewCompanies.website" /></th>
                            <th><FormattedMessage id="Entities_Preview_UIText_previewCompanies.alternateNames" /></th>
                            <th><FormattedMessage id="Entities_Preview_UIText_previewCompanies.contextKeywords" /></th>
                            <th><FormattedMessage id="Entities_Preview_UIText_previewCompanies.excludedKeywords" /></th>
                            <th><FormattedMessage id="Entities_Preview_UIText_previewCompanies.categories" /></th>
                        </tr>
                    </thead>
                    <CustomTableBody tableId="preview-companies-table"
                                     url={ '/api/template/temp-entities/' + this.state.uploadId }
                                     startPageNumber="0"
                                     pageSize="50"
                                     urlParams={this.urlParams} />
                </InfiniteScrollTable>

                <div className="upload-preview-page__bottom-buttons">

                    <button
                        className="button-secondary-lg cancel"
                        onClick={actions.resetUploadToInitial}>
                        <FormattedMessage id="General_CoreFunctionality_UIText_general.cancel" />
                    </button>

                    <button className="button-primary-lg continue"
                            onClick={actions.continueAndCommit}>
                        <FormattedMessage id="General_CoreFunctionality_UIText_general.continue" />
                    </button>

                </div>

            </div>
        );

    }
}



// WEBPACK FOOTER //
// ./src/scripts/pages/BatchUpload/submodules/PreviewPage/PreviewPage.index.jsx